<template>
  <div>
    <m-register-1 :image="require('../assets/login.svg')" class="my-5"/>
  </div>
</template>

<script>

export default {
  name: "Register",
};
</script>
<style scoped>

</style>